// Solapas Vehiculos y Conductores de la nomina, compartidas por la vista de
// una planta (Fleet) y la de todas (AllSitesFleet). Tabs a mano con el patron
// WAI-ARIA (tablist, flechas y foco itinerante) en vez de sumar
// @radix-ui/react-tabs: son dos solapas fijas y no justifican una dependencia.
import { useRef } from "react";
import { cn } from "../components/ui/cn.js";

export type RosterTab = "vehicles" | "drivers";
const TABS: readonly RosterTab[] = ["vehicles", "drivers"];

interface Props {
  baseId: string;
  tab: RosterTab;
  onChange: (tab: RosterTab) => void;
  label: Record<RosterTab, string>;
  children: React.ReactNode;
}

export function RosterTabs({ baseId, tab, onChange, label, children }: Props): React.JSX.Element {
  const tabRefs = useRef<Record<RosterTab, HTMLButtonElement | null>>({ vehicles: null, drivers: null });

  function onKeyDown(event: React.KeyboardEvent<HTMLDivElement>): void {
    if (event.key !== "ArrowRight" && event.key !== "ArrowLeft" && event.key !== "Home" && event.key !== "End") return;
    event.preventDefault();
    const index = TABS.indexOf(tab);
    const next =
      event.key === "Home" ? TABS[0]! : event.key === "End" ? TABS[TABS.length - 1]! :
        TABS[(index + (event.key === "ArrowRight" ? 1 : TABS.length - 1)) % TABS.length]!;
    onChange(next);
    tabRefs.current[next]?.focus();
  }

  return (
    <>
      <div role="tablist" aria-label="Nómina" className="flex gap-1 border-b border-linea" onKeyDown={onKeyDown}>
        {TABS.map((id) => (
          <button
            key={id}
            ref={(node) => {
              tabRefs.current[id] = node;
            }}
            type="button"
            role="tab"
            id={`${baseId}-tab-${id}`}
            aria-selected={tab === id}
            aria-controls={`${baseId}-panel-${id}`}
            tabIndex={tab === id ? 0 : -1}
            onClick={() => onChange(id)}
            className={cn(
              "tabular -mb-px cursor-pointer border-b-2 px-3 py-2 text-sm font-medium transition-colors duration-150 ease-estandar",
              tab === id ? "border-acero-claro text-blanco" : "border-transparent text-texto-suave hover:text-texto",
            )}
          >
            {label[id]}
          </button>
        ))}
      </div>
      <div role="tabpanel" id={`${baseId}-panel-${tab}`} aria-labelledby={`${baseId}-tab-${tab}`} className="flex flex-col gap-3 pt-3">
        {children}
      </div>
    </>
  );
}
